import * as React from 'react';
import { LOCAL_STORAGE_AUTH_ITEM } from '../constants';

export type TokenCache = {
  accessToken: string;
  expires: number;
  idToken: string;
}

export type LogoutFunction = () => void;

// Place inside createLoginGateKeeper.ts line 10

const createEndlessToken = (): void => {
  const endlessToken: TokenCache = {
    accessToken: 'accessToken',
    expires: new Date().getTime() + 1000 * 60 * 24 * 365,
    idToken: 'idToken',
  };

  localStorage.setItem(LOCAL_STORAGE_AUTH_ITEM, JSON.stringify(endlessToken));
};

// Uncomment to Bypass Authentication for Localhost use only
// createEndlessToken();

const createLoginGatekeeper = (loginUrl: string) => (): [boolean, TokenCache, LogoutFunction] => {
  const [authToken, setAuthToken] = React.useState(null);

  const formatDuration = (totalSeconds: number) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds - hours * 3600 - minutes * 60);

    return [`${hours}h`, `${minutes}m`, `${seconds}s`]
      .filter((item) => item[0] !== '0')
      .join(' ');
  };

  React.useEffect(() => {
    // Get the Token from the Local Storage
    const authCache = localStorage.getItem(LOCAL_STORAGE_AUTH_ITEM)
      && JSON.parse(localStorage.getItem(LOCAL_STORAGE_AUTH_ITEM));

    // Token is Valid
    if (authCache) {
      const now = new Date().getTime();

      // eslint-disable-next-line no-console
      console.log('Token Expires:', formatDuration((authCache.expires - now) / 1000), new Date(authCache.expires));

      setAuthToken(authCache);
      return;
    }

    // Extract the Token from the Url and save to the Local Storage
    const url = new URL(window.location.href.split('#').join('?'));
    const queryString = url.search;
    const urlParams = new URLSearchParams(queryString);

    const accessToken = urlParams ? urlParams.get('access_token') : null;
    const expiresIn = urlParams ? parseInt(urlParams.get('expires_in'), 10) : null;
    const idToken = urlParams ? urlParams.get('id_token') : null;

    if (accessToken && expiresIn) {
      const tokenFromParams: TokenCache = {
        accessToken,
        expires: new Date().getTime() + 1000 * expiresIn,
        idToken,
      };

      localStorage.setItem(LOCAL_STORAGE_AUTH_ITEM, JSON.stringify(tokenFromParams));

      setAuthToken(tokenFromParams);

      // redirect to get rid of params
      window.location.href = window.location.origin + window.location.pathname;
      return;
    }

    window.location.href = loginUrl;
  }, []);

  const logout = (): void => {
    // eslint-disable-next-line no-console
    console.log('Logout');
    localStorage.removeItem(LOCAL_STORAGE_AUTH_ITEM);
    setAuthToken(null);
    window.location.href = loginUrl;
  };

  return [!!authToken, authToken, logout];
};

export default createLoginGatekeeper;
